// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"aa3703bb","114":"fd805a06","153":"dc4baffb","237":"96262bd4","264":"c64e9039","487":"2bf7ece6","529":"77ea86bc","638":"bcc0580b","855":"89c46985","889":"29eee34a","955":"34a71c1c","982":"d15e3ebc","988":"b59cde49"}[chunkId] + ".chunk.js";
};